import { ConsignmentStockInDetailPage } from "@/features/consignment-stockin/pages/ConsignmentStockInDetailPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/consignment-stockin/$id/detail")({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["consignment_stock_in.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: ConsignmentStockInDetailPage,
});
